
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  // PdaUsercodename,
  // DestinationOrgcodename,
  LineListcodename
} from "@/views/components";
@Component({
  name: "Form1",
  components: { LineListcodename },
  props: {
    callbackdata: {
      type: Object,
      default: false
    }
  },
  watch: {
    callbackdata(newone, oldone) {
      if (newone.input_CarSignNum != this.inputModel.input_CarSignNum) {
        this.inputModel = newone;
        return;
      }
      if (
        newone.input_MidSignatureNum != this.inputModel.input_MidSignatureNum
      ) {
        this.inputModel = newone;
        return;
      }
      if (
        newone.input_LastSignatureNum != this.inputModel.input_LastSignatureNum
      ) {
        this.inputModel = newone;
        return;
      }
      if (newone.input_LineNum != this.inputModel.input_LineNum) {
        this.inputModel = newone;
        return;
      }
      if (newone.input_LineNumName != this.inputModel.input_LineNumName) {
        this.inputModel = newone;
        return;
      }
      if (newone.input_LoadingVolume != this.inputModel.input_LoadingVolume) {
        this.inputModel = newone;
        return;
      }
      if (newone.input_CarCode != this.inputModel.input_CarCode) {
        this.inputModel = newone;
        return;
      }
    }
  }
})
export default class extends Vue {
  private inputModel: inputDataModel_SealCar = {
    input_ScanCode: "",
    input_CarSignNum: "",
    input_MidSignatureNum: "",
    input_LastSignatureNum: "",
    input_LineNum: "",
    input_LineNumName: "",
    input_LoadingVolume: "",
    input_CarCode: ""
  };
  mounted() {
    this.$emit("get-form1-value", this.inputModel);
  }
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }
  private linelistdialogshow = false;
  public linelistcodenameFunc(linelistModel) {
    this.linelistdialogshow = false;
    if (linelistModel != null) {
      this.inputModel.input_LineNum = linelistModel.lineNo;
      this.inputModel.input_LineNumName = linelistModel.lineName;
    }
  }
  public findlinelistcodename() {
    this.linelistdialogshow = true;
  }
  private clearlinecodename() {

    this.inputModel.input_LineNum = "";
    this.inputModel.input_LineNumName = "";
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    // this.$refs.singleTable.setCurrentRow(row);
    this.$refs.singleTable[0].setCurrentRow();
  }
}
